/* ── LF: Descripción en acordeón ── */
(function() {
  function wrapDescription() {
    var rte = document.querySelector('.product-block-area .rte[x-data="RTE"]');
    if (!rte) return false;

    var block = rte.closest('.product-block');
    if (!block || block.classList.contains('lf-accordion')) return false;

    var content = block.innerHTML;
    var locale = document.documentElement.lang || 'en';
    var label = locale.startsWith('es') ? 'Descripción' : 'Description';

    block.innerHTML = '<details class="lf-details" open>' +
      '<summary class="lf-summary">' +
        '<span class="lf-summary-label">' + label + '</span>' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>' +
      '</summary>' +
      '<div class="lf-details-content">' + content + '</div>' +
    '</details>';

    block.classList.add('lf-accordion');
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapDescription);
  } else {
    setTimeout(wrapDescription, 100);
  }
})();

/* ── LF: Banner de duties en el drawer del carrito ── */
(function() {
  var usTimezones = [
    'America/New_York', 'America/Chicago', 'America/Denver',
    'America/Los_Angeles', 'America/Anchorage', 'America/Adak',
    'Pacific/Honolulu', 'America/Phoenix', 'America/Boise',
    'America/Detroit', 'America/Indiana', 'America/Kentucky'
  ];

  function isLikelyUS() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      for (var i = 0; i < usTimezones.length; i++) {
        if (tz.indexOf(usTimezones[i]) === 0) return true;
      }
      /* Fallback: check broader America/ zones that are US */
      if (tz.indexOf('America/') === 0) {
        var city = tz.split('/')[1] || '';
        var usCities = ['New_York','Chicago','Denver','Los_Angeles','Anchorage',
          'Honolulu','Phoenix','Boise','Detroit','Juneau','Nome','Sitka',
          'Indianapolis','Louisville','Menominee','Vincennes','Winamac',
          'Marengo','Petersburg','Vevay','Tell_City','Knox','Beulah',
          'Center','New_Salem','Shiprock'];
        for (var j = 0; j < usCities.length; j++) {
          if (city === usCities[j]) return true;
        }
      }
    } catch(e) {}
    return false;
  }

  function isLikelyNonEU() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      var euPrefixes = ['Europe/', 'Atlantic/Canary', 'Atlantic/Madeira', 'Atlantic/Azores'];
      for (var i = 0; i < euPrefixes.length; i++) {
        if (tz.indexOf(euPrefixes[i]) === 0) return false;
      }
      return true;
    } catch(e) {}
    return false;
  }

  function insertBanner() {
    if (document.getElementById('lf-duties-banner')) return;
    if (!isLikelyNonEU()) return;

    var locale = document.documentElement.lang || 'en';
    var isES = locale.startsWith('es');
    var isUS = isLikelyUS();

    var title, text;
    if (isES) {
      title = 'Clientes fuera de la UE';
      text = 'Debido a cambios recientes en las normativas aduaneras, <strong>pueden aplicarse aranceles e impuestos de importación</strong> que serán abonados por el cliente en la entrega.';
    } else if (isUS) {
      title = 'US customers';
      text = 'Due to recent customs changes, <strong>duties and taxes may apply</strong> and are paid by customers upon delivery. We\'re sorry for the inconvenience and hope to simplify this process very soon.';
    } else {
      title = 'Customers outside the EU';
      text = 'Due to recent customs changes, <strong>duties and taxes may apply</strong> and are paid by customers upon delivery.';
    }

    var banner = document.createElement('div');
    banner.id = 'lf-duties-banner';
    banner.style.cssText = 'background:rgba(0,0,0,0.03);border-radius:6px;padding:10px 12px;margin:10px 0;font-size:12px;line-height:1.55;color:rgba(0,0,0,0.55);';
    banner.innerHTML = '<span style="font-weight:500;color:rgba(0,0,0,0.7);display:block;margin-bottom:2px;font-size:11px;letter-spacing:0.03em;">' + title + '</span>' + text;

    /* Buscar el contenedor del checkout en el drawer */
    var targets = [
      document.querySelector('[data-drawer-cart-footer]'),
      document.querySelector('.drawer-cart-footer'),
      document.querySelector('[data-cart-footer]'),
      document.querySelector('.cart-footer')
    ];

    var target = null;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i]) { target = targets[i]; break; }
    }

    if (target) {
      target.insertBefore(banner, target.firstChild);
    } else {
      /* Fallback: buscar el botón de checkout */
      var checkoutBtn = document.querySelector('[name="checkout"]')
        || document.querySelector('button[type="submit"][href*="checkout"]')
        || document.querySelector('.cart__checkout-button');
      if (checkoutBtn && checkoutBtn.parentNode) {
        checkoutBtn.parentNode.insertBefore(banner, checkoutBtn);
      }
    }
  }

  /* Observar el DOM porque el drawer se inyecta dinámicamente */
  var observer = new MutationObserver(function() {
    if (document.querySelector('[data-drawer-cart-footer], .drawer-cart-footer, [data-cart-footer], .cart-footer, [name="checkout"]')) {
      if (!document.getElementById('lf-duties-banner') && isLikelyNonEU()) {
        setTimeout(insertBanner, 200);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /* Intentar insertar inmediatamente también */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(insertBanner, 500); });
  } else {
    setTimeout(insertBanner, 500);
  }
})();